var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0006 13.3683C30.2524 13.3683 30.4938 13.2683 30.6717 13.0902C30.8946 12.8675 32.8482 10.8495 32.8482 8.62221C32.8482 8.26537 32.6451 7.93523 32.3249 7.77392L17.0741 0.116893C16.8062 -0.0176428 16.4902 -0.0176428 16.2223 0.116893L0.971515 7.77392C0.65783 7.932 0.448242 8.25955 0.448242 8.62221C0.448242 10.8491 2.40104 12.8666 2.62455 13.0901C2.80756 13.2733 3.05802 13.3683 3.2959 13.3683H4.24512V26.7206H3.2959C3.0441 26.7206 2.80268 26.8207 2.62474 26.9987C2.40192 27.2214 0.448242 29.2394 0.448242 31.4667C0.448242 31.991 0.873239 32.416 1.39746 32.416H31.899C32.4232 32.416 32.8482 31.991 32.8482 31.4667C32.8482 29.2394 30.8946 27.2215 30.6717 26.9987C30.4938 26.8206 30.2524 26.7206 30.0006 26.7206H29.0514V13.3683H30.0006ZM16.6482 2.02735L27.8929 7.67299H5.40361L16.6482 2.02735ZM29.5834 28.6191C29.9562 29.054 30.4784 29.7711 30.7569 30.5175H2.53956C2.81825 29.7707 3.34076 29.0533 3.71299 28.6191H29.5834ZM6.14356 26.7206V13.3683H8.04199V26.7206H6.14356ZM9.94043 26.7206V13.3683H13.8006V26.7206H9.94043ZM15.699 26.7206V13.3683H17.5975V26.7206H15.699ZM19.4959 26.7206V13.3683H23.3561V26.7206H19.4959ZM25.2545 26.7206V13.3683H27.1529V26.7206H25.2545ZM3.71311 11.4699C3.34039 11.0351 2.81831 10.3179 2.53975 9.5708H30.7565C30.4779 10.3183 29.9558 11.0357 29.5835 11.4699H3.71311Z",
    fill: "#5361DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.4,
    height: 32.4,
    fill: "white",
    transform: "translate(0.448242 0.0159912)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.e74a5742305ed506c61ca05d8fc99a1b.svg";
export { ForwardRef as ReactComponent };